export const HIVE_RECIPIENT = 'hive';
export const FARM_RECIPIENT = 'farm';
